var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-wrap"},[_c('van-image',{attrs:{"width":"48","height":"48","src":require('@/assets/images/login/ngt-logo.png')}}),_c('div',{staticClass:"line"}),_c('van-image',{attrs:{"width":"48","height":"48","src":require('@/assets/images/login/ccx-logo.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }